<template>
  <div>
    <div class="footer-widget section-pad">
      <div class="container">
        <div class="row">
          <div class="widget-row row">
            <div class="footer-col col-md-3 col-sm-6 res-m-bttm">
              <!-- Each Widget -->
              <div class="wgs wgs-footer wgs-text">
                <div class="wgs-content">
                  <p>
                    <img
                      src="image/logo-light.png"
                      srcset="image/logo-light2x.png 2x"
                      alt=""
                    />
                  </p>
                  <p>
                    We are committed to giving our people opportunities they do
                    not get anywhere else: A Career path, Training, compensation
                    and a chance to do work that creates live impact in people
                  </p>
                </div>
              </div>
              <!-- End Widget -->
            </div>
            <div
              class="footer-col col-md-3 col-sm-6 col-md-offset-1 res-m-bttm"
            >
              <!-- Each Widget -->
              <div class="wgs wgs-footer wgs-menu">
                <h5 class="wgs-title">Our Services</h5>
                <div class="wgs-content">
                  <ul class="menu">
                    <li><a href="#">Restaurants</a></li>
                    <li>
                      <a href="#">Industrial Catering and House Keeping</a>
                    </li>
                    <li><a href="#">Events Catering and Management</a></li>
                    <li><a href="#">Bakery</a></li>
                  </ul>
                </div>
              </div>
              <!-- End Widget -->
            </div>
            <div class="footer-col col-md-2 col-sm-6 res-m-bttm">
              <!-- Each Widget -->
              <div class="wgs wgs-footer wgs-menu">
                <h5 class="wgs-title">Links</h5>
                <div class="wgs-content">
                  <ul class="menu">
                    <li><a href="/">Home</a></li>
                    <li><a href="/contact">Contact Us</a></li>
                  </ul>
                </div>
              </div>
              <!-- End Widget -->
            </div>

            <div class="footer-col col-md-3 col-sm-6">
              <!-- Each Widget -->
              <div class="wgs wgs-footer">
                <h5 class="wgs-title">Get In Touch</h5>
                <div class="wgs-content">
                  <p>
                    <strong>Sundry Markets Ltd</strong><br />
                    23 Nzimiro street, Old GRA <br />
                    Port Harcourt, Nigeria <br />
                  </p>
                  <!-- <p><span>General Enquiries</span>: <a href="mailto:info@sundryfood.com">info@sundryfood.com</a><br> </p>
                 
										<span>Job Application Enquiries</span>: <a href="mailto:info@sundryfood.com">hr@sundryfood.com</a></p> -->
                  <ul class="social">
                    <li>
                      <a href="https://www.instagram.com/marketsquarengr?igsh=MWdyazZ5cjZ0cDJ0Mg=="
                        ><em class="fa fa-instagram" aria-hidden="true"></em
                      ></a>
                    </li>
                    <li>
                      <a href="#"
                        ><em class="fa fa-twitter" aria-hidden="true"></em
                      ></a>
                    </li>
                    <li>
                      <a href="https://www.linkedin.com/company/sundry-markets-limited/"
                        ><em class="fa fa-linkedin" aria-hidden="true"></em
                      ></a>
                    </li>
                  </ul>
                </div>
              </div>
              <!-- End Widget -->
            </div>
          </div>
          <!-- Widget Row -->
        </div>
      </div>
    </div>
    <div class="copyright">
      <div class="container">
        <div class="row">
          <div class="site-copy col-sm-7">
            <p>
              &copy; {{ currentYear }} Sundry Markets HR
              <span class="sep"></span>
            </p>
          </div>
          <!-- <div class="site-by col-sm-5 al-right">
						<p>By <a href="https://wajesmart.com" target="_blank">Waje Smart Solutions</a></p>
					</div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  computed: {
    currentYear() {
      return new Date().getFullYear();
    },
  },
};
</script>
